var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6383 14.9029C22.0356 21.3315 15.5244 25.2438 9.09503 23.6407C2.66833 22.038 -1.24401 15.5265 0.359382 9.09837C1.96137 2.66903 8.47253 -1.24361 14.8999 0.359081C21.3289 1.96177 25.241 8.47404 23.6381 14.903L23.6382 14.9029H23.6383Z",
    fill: "#F4F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05661 11.9904L5.03805 14.0097L3 11.9904L5.0373 9.95311L7.05661 11.9904ZM11.9914 7.05564L15.4681 10.5323L17.5061 8.49576L11.9914 2.99902L6.47667 8.51374L8.51472 10.5503L11.9914 7.05564ZM18.9455 9.95311L16.9262 11.9904L18.9635 14.0277L21 11.9904L18.9455 9.95311ZM11.9914 16.9252L8.51472 13.4305L6.47667 15.4678L11.9914 20.9818L17.5061 15.4671L15.4681 13.4305L11.9914 16.9252ZM11.9914 14.0105L14.0287 11.9724L11.9914 9.95386L9.95409 11.9904L11.9914 14.0097V14.0105Z",
    fill: "#F0AC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9973,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.a661ec9ec3229cbded95eafca1a0c670.svg";
export { ForwardRef as ReactComponent };